// import fileHelper from "../fileHelper"
import EnvironmentCubeMap from "./EnvironmentCubeMap"
import EnvironmentSphericalHarmonics from "./EnvironmentSphericalHarmonics"
import EnvironmentPanorama from "./EnvironmentPanorama"
import IntegrateBRDF from "./IntegrateBRDF"
import {
    Vector3
} from "three"
class Envirment {
    constructor() {
        this._config = undefined;
        this._promises = [];
        this._panoramaUE4 = {};
        this._cubemapUE4 = {};
        this._backgroundCubemap = {};
        this._backgroundPanorama = {};
        this._files = {};
        this.useCubeEnvirment = true;
    }
    // async loadPackage(urlOfFile) {
    //     var filesMap = await fileHelper.unzip(urlOfFile);
    //     console.log(filesMap)
    //     return this.readZipContent(filesMap, urlOfFile)
    // }
    async readZipContent(filesMap, url, useCubeEnvirment) {
        this.useCubeEnvirment = useCubeEnvirment;
        url.split('/')
            .pop()
            .split('.zip')[0];
        for (var filename in filesMap) {
            var data = filesMap[filename];
            var name = filename.split('/').pop();
            this._files[name] = data;
        }
        return this.initData(this._files['config.json'])
    }
    initData(config) {
        this._config = config;
        // read all cubemap format U4
        // 读取所有立方图格式U4
        //envMap
        if (this.useCubeEnvirment) {
            let textureConfig = this.getTextures('specular_ue4', 'luv', 'cubemap')
            var minTextureSize = textureConfig[0].limitSize;

            var texture = this.getImage('specular_ue4', 'luv', 'cubemap');
            var file = texture.file;
            var size = texture.width;
            this.nbLod = Math.log(size) / Math.LN2;
            this.maxLod = this.nbLod - Math.log(minTextureSize) / Math.LN2;
            this._cubemapUE4.nbLod = Math.log(size) / Math.LN2;
            this._cubemapUE4.maxLod = this._cubemapUE4.nbLod - Math.log(minTextureSize) / Math.LN2;

            var urlOrData = this._files[file];
            this._cubemapUE4['LUV'] = new EnvironmentCubeMap(urlOrData, size, config);
            this._cubemapUE4['LUV'].loadPacked('LUV')
        } else {
            let textureConfig = this.getTextures('specular_ue4', 'luv', 'panorama')
            var minTextureSize = textureConfig[0].limitSize;

            var texture = this.getImage('specular_ue4', 'luv', 'panorama');
            var file = texture.file;
            var size = texture.width;
            this._panoramaUE4.nbLod = Math.log(size) / Math.LN2;
            this._panoramaUE4.maxLod = this._panoramaUE4.nbLod - Math.log(minTextureSize) / Math.LN2;
            var urlOrData = this._files[file];
            this._panoramaUE4['LUV'] = new EnvironmentPanorama(urlOrData, size, config);
            this._panoramaUE4['LUV'].loadPacked('LUV');

        }



        if (!config.diffuseSPH) console.error('cant find shCoefs in environment config');
        this._spherical = new EnvironmentSphericalHarmonics(config.diffuseSPH);
        if (config.Lights) {
            let sunlight = config.Lights[0];
            this.sunlightInfo = {
                position: new Vector3().fromArray(sunlight.direction).negate(),
            }
        }
    }

    getImage(type, encoding, format) {
        var results = this.getTextures(type, encoding, format);

        if (!results.length) return undefined;

        return results[0].images[0];
    }
    getTextures(type, encoding, format) {
        var textures = this._config.textures;
        var results = textures.filter(function (texture) {
            return (
                texture.encoding === encoding &&
                texture.format === format &&
                texture.type === type
            );
        });

        return results;
    }
}
export default Envirment